// extracted by mini-css-extract-plugin
export default {"description":"description-z6Z10YVA"};